import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { DataEntryRoutes, DataEntryRoutesStates } from '../../shared/constants/data-entry-routes.constant';
import { UtilitiesService } from '../../shared/services/utilities/utilities.service';
import { ISchoolAssessment } from '../../shared/typings/interfaces/school-assessment.interface';
import { ISchool } from '../../shared/typings/interfaces/school.interface';
import { IStudentAssessment } from '../../shared/typings/interfaces/student-assessment.interface';
import { IUser } from '../../shared/typings/interfaces/user.interface';

@Component({
  selector: 'nv-data-entry',
  template: require('./data-entry.component.html'),
  styles: [require('./data-entry.component.scss')],
})
export class DataEntryComponent implements OnInit {
  @ViewChild('textContainer') textContainer: ElementRef;
  @Input() currentUser: IUser;
  @Input() schoolAssessments$: Observable<ISchoolAssessment[]>;
  @Input() studentAssessments$: Observable<IStudentAssessment[]>;
  @Input() currentRoute: string;
  @Input() currentSchool: ISchool;

  public dataEntryRoute: string;
  public DataEntryRoutes = DataEntryRoutes;
  public displayBoxShadow = false;
  public schoolId: string;

  constructor(@Inject('$state') private $state, private utilitiesService: UtilitiesService) {
    //
  }

  ngOnInit() {
    this.dataEntryRoute = 'Assessments';
    this.schoolId = this.currentSchool._id;
  }

  public changeView(route: string): void {
    if (route !== this.dataEntryRoute) {
      this.$state.go(DataEntryRoutesStates[route]);
    }
  }

  public onWindowScroll(): void {
    const scrollTop = this.textContainer.nativeElement.scrollTop;
    this.displayBoxShadow = this.utilitiesService.showListPanelShadow(scrollTop);
  }
}
